import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from "react";

import { cn } from "../lib/utils";

import { FieldError } from "./FieldError";

type CheckboxProps = {
	label?: ReactNode;
	error?: string;
} & ComponentPropsWithoutRef<"input">;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
	({ label, className, id, error, ...props }, ref) => {
		return (
			<div className="w-full">
				<label htmlFor={id} className={cn("flex cursor-pointer items-start gap-3", props.disabled && "opacity-60")}>
					<input
						ref={ref}
						type="checkbox"
						id={id}
						aria-invalid={error ? true : undefined}
						className={cn(
							"h-[20px] w-[20px] rounded-lg border border-input text-[#699F11] transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#699F11]/60 hover:border-[#699F11]",
							"accent-[#699F11]",
							error && "border-red-500",
							className,
						)}
						{...props}
					/>
					{label && <span className="text-base font-[500] text-foreground">{label}</span>}
				</label>
				<FieldError message={error} />
			</div>
		);
	},
);
Checkbox.displayName = "Checkbox";
